import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padLeft'
})
export class PadLeftPipe implements PipeTransform {
  transform(value: number | string, totalDigits: number): string {
    let strValue = value.toString();
    return strValue.padStart(totalDigits, '0');
  }
}
